<template>
  <div>
     <b-modal id="order_events_timeline_modal" size="lg" ok-only >
        <header>
    <h3>Order Events Timeline</h3>
    <h1>{{ orderDetails.orderNo }}</h1>
</header>

<ul class="timeline-filters">
  <li v-for="field in filterFields" :key="field" @click="toggleFilterValue(field)" :class="{activeTimelineFilter: filterArr.includes(field)}">
    {{ styleFilterField(field) }}
  </li>
</ul>


      <div v-if="processing">
         <bar-loader />
      </div>
      <ul class="timeline" v-if="!processing && filteredEventsData.length > 0">

        <single-event-box v-for="(event, index) in filteredEventsData" :key="event.id" :single-event="event" :index-key="index" :last-event-time="index != (filteredEventsData.length - 1) ? filteredEventsData[index + 1].event_time : null"/>

      </ul>
      <div v-if="!processing && filteredEventsData.length == 0">
         No Timeline Events Found
      </div>

      

     </b-modal>
  </div>
</template>

<script>
const SingleEventBox = () => import(/* webpackChunkName: "single-event-box" */ "./single-event-box.vue")

import BarLoader from '../../../components/common/bar-loader.vue'
import EventBus from '../../../EventBus';
import OrdersService from '../../../services/orders.service';

  export default {
      data(){
        return {
           orderEvents: [],
           orderDetails:{},
           filterArr: [],
           processing: false
        }
      },
      components: {
        SingleEventBox,
        BarLoader
      },
      mounted(){
        EventBus.$on("show-order-events-timeline", orderPk => {
             console.log(orderPk)
             this.fetchOrderEvents(orderPk)
        });
      },
      methods: {
        async fetchOrderEvents(orderPk) {
           try{
              this.processing = true;
              this.orderEvents = []

              

               const result = await OrdersService.fetchOrderEvents(orderPk)

               this.orderEvents = result.data.combinedEventHistoryArray;
               this.orderDetails = result.data.orderDetails

            
              
           }catch(Errors){
             console.log(Errors)
           }finally{
              this.processing = false;
           }
        },
        styleFilterField(field){
           field = field.replace(/-/g, ' ')
           return field.charAt(0).toUpperCase() + field.slice(1);
        },
        toggleFilterValue(field){
           if(!this.filterArr.includes(field)){
              this.filterArr.push(field)
           }else{
              const index = this.filterArr.indexOf(field);
              if (index > -1) {
                this.filterArr.splice(index, 1);
              }
           }
        }
      },
      computed:{
         filterFields(){
             let filterArr = [];
             return this.orderEvents.filter(event => {
                 if(!filterArr.includes(event.event_type)){
                    filterArr.push(event.event_type)
                    return true;
                 }else{
                   return false;
                 }
             }).map(event => event.event_type)
         },
         filteredEventsData(){
             return this.orderEvents.filter(event => {
                if(this.filterArr.length == 0 || this.filterArr.includes(event.event_type)){
                   return true;
                }else{
                  return false;
                }
             })
         }
      },
      beforeDestroy(){
        EventBus.$off("show-order-events-timeline");
      }
  }
</script>

<style lang="scss" scoped>

</style>